var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elem-container",style:({
    transformOrigin: (_vm.ox + "px " + _vm.oy + "px"),
    transform: ("translate(" + _vm.x + "px, " + _vm.y + "px) scale(" + _vm.s + ") rotate(" + _vm.r + "deg)"),
    transition: ("transform " + _vm.dur + "ms 0s " + _vm.easing + ",\n    transform-origin " + _vm.dur + "ms 0s " + _vm.easing),
    'will-change': _vm.isWillChangeEnabled ? 'transform' : 'auto',
  }),on:{"click":_vm.clicked}},[_vm._t("default"),(_vm.debug)?_c('div',{staticClass:"debug",style:({
    transform: ("translate(" + _vm.ox + "px, " + _vm.oy + "px)")
  })},[_c('div',{staticClass:"debug-origin"})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }